import { PermissionCategory, PermissionCodes } from "types/role";

export const permissions: PermissionCategory[] = [
  {
    items: [
      {
        code: PermissionCodes.STORES,
        name: "stores",
        description: "storesDescription",
      },
    ],
  },
  {
    category: "settings",
    items: [
      {
        code: PermissionCodes.ACL,
        name: "acl",
        description: "aclDescription",
      },
      {
        code: PermissionCodes.ADMIN,
        name: "admins",
        description: "adminsDescription",
      },
      {
        code: PermissionCodes.AUDIT,
        name: "auditLog",
        description: "auditLogDescription",
      },
      {
        code: PermissionCodes.CHANNEL,
        name: "channels",
        description: "channelsDescription",
      },
      {
        code: PermissionCodes.LANGUAGE,
        name: "language",
        description: "languageDescription",
      },
      {
        code: PermissionCodes.TRANSLATIONS,
        name: "translations",
        description: "translationsDescription",
      },
      {
        code: PermissionCodes.SETTINGS,
        name: "settings",
        description: "settingsDescription",
      },
      {
        code: PermissionCodes.TECH_SETTINGS,
        name: "technicalSettings",
      },
    ],
  },
  {
    category: "members",
    items: [
      {
        code: PermissionCodes.CUSTOMER,
        name: "members",
        description: "membersDescription",
      },
      {
        code: PermissionCodes.SEGMENT,
        name: "segments",
        description: "segmentsDescription",
      },
      {
        code: PermissionCodes.CUSTOM_EVENT,
        name: "customEvents",
        description: "customEventsDescription",
      },
      {
        code: PermissionCodes.TRANSACTION,
        name: "transactions",
        description: "transactionsDescription",
      },
      {
        code: PermissionCodes.BADGE,
        name: "badge",
        description: "badgeAclDescription",
      },
    ],
  },
  {
    category: "analytics",
    items: [
      {
        code: PermissionCodes.DATA_ANALYTICS,
        name: "dashboardGeneralOverview",
        description: "generalOverviewAnalyticsDescription",
      },
      {
        code: PermissionCodes.ANALYTICS,
        name: "home",
        description: "homeAnalyticsDescription",
      },
      {
        code: PermissionCodes.DATA_ANALYTICS_CAMPAIGN,
        name: "singleCampaignOverview",
        description: "singleCampaignOverviewDescription",
      },
    ],
  },
  {
    category: "globalManagement",
    items: [
      {
        code: PermissionCodes.GLOBAL_MANAGEMENT,
        name: "globalManagement",
        description: "globalManagementDescription",
      },
      {
        code: PermissionCodes.BILLABLE_REPORTS,
        name: "usage",
        description: "billableReportsDescription",
      },
    ],
  },
  {
    category: "rewards",
    items: [
      {
        code: PermissionCodes.ISSUED_REWARDS,
        name: "issuedRewards",
        description: "issuedRewardsDescription",
      },
      {
        code: PermissionCodes.REWARDS,
        name: "rewards",
        description: "rewardsDescription",
      },
      {
        code: PermissionCodes.REWARDS_CATEGORIES,
        name: "rewardsCategories",
        description: "rewardsCategoriesDescription",
      },
    ],
  },
  {
    category: "exportsImports",
    items: [
      {
        code: PermissionCodes.EXPORT,
        name: "exports",
        description: "exportsDescription",
      },
      {
        code: PermissionCodes.IMPORT,
        name: "imports",
        description: "importsDescription",
      },
      {
        code: PermissionCodes.BULK_ACTIONS,
        name: "massActions",
        description: "massActionsDescription",
      },
    ],
  },
  {
    category: "wallets",
    items: [
      {
        code: PermissionCodes.WALLET,
        name: "wallets",
        description: "walletsDescription",
      },
      {
        code: PermissionCodes.POINT_TRANSFER,
        name: "unitsTransfers",
        description: "unitsTransfersDescription",
      },
    ],
  },
  {
    category: "otherModules",
    items: [
      {
        code: PermissionCodes.WEBHOOK_SUBSCRIPTION,
        name: "webhookSubscriptions",
        description: "webhookDescription",
      },
      {
        code: PermissionCodes.GROUP_OF_VALUES,
        name: "collections",
        description: "collectionsDescription",
      },
      {
        code: PermissionCodes.LEVEL,
        name: "tiers",
        description: "tiersDescription",
      },
      {
        code: PermissionCodes.CAMPAIGN,
        name: "campaigns",
        description: "campaignsDescription",
      },
    ],
  },
];
